module.exports = __webpack_public_path__ + "img/success_OLD_d.4d751047.gif";